module.exports = __webpack_public_path__ + "static/media/fruit_basket.10abfef4.png";